import classNames from 'classnames';

import { TEMPO } from 'lib/constants';
import style from 'styles/components/menuSearch/MealCard';

const OrderableMenuLabel = ({ date, mealPlanSlug = '' }) => {
  const isTempo = mealPlanSlug === TEMPO;

  return (
    <span
      className={classNames(
        style.orderableMenuLabel,
        'h7 absolute bottom-4 left-2 bg-white-100 uppercase shadow-md bp1:left-4',
        {
          'text-xxs font-semibold text-green-100 bp1:text-sm bp1:font-normal': !isTempo,
          'tempo text-tempo-blue-90': isTempo,
        },
        'rounded-full px-4 py-1.5 bp1:px-5 bp1:py-2' // pill shape
      )}
    >
      Week of {date}
    </span>
  );
};

OrderableMenuLabel.propTypes = {
  date: PropTypes.string.isRequired,
  mealPlanSlug: PropTypes.string,
};

export default OrderableMenuLabel;
